import { render } from "./CollaboratorDetails.vue?vue&type=template&id=91458b88&scoped=true"
import script from "./CollaboratorDetails.vue?vue&type=script&lang=js"
export * from "./CollaboratorDetails.vue?vue&type=script&lang=js"

import "./CollaboratorDetails.vue?vue&type=style&index=0&id=91458b88&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91458b88"]])

export default __exports__